<template>
  <div class="inside_container">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <section class="top_banner">
      <div class="middle_content img_default" :style="getBackgrounUrl(currentArea.banner_img)">
        <p class="left_p">プランお申し込みページ</p>
        <div>
          <h3>{{currentArea.title}}</h3>
          <p class="sub_title">- {{currentArea.name}} -</p>
        </div>
      </div>
    </section>
    <section class="area_content">
      <h3 class="top_title">
        <span class="img_default">プランを選択する</span>
      </h3>
      <div class="sub_title_content" v-if="filteredMultiple.length">
        <h4>
          <span>周遊プラン</span>
        </h4>
        <p>2カ国以上渡航予定の方は「周遊プラン」！</p>
      </div>
      <div class="travel_plan_content clearfix" v-if="filteredMultiple.length">
        <div class="plan_info">
          <p
            v-if="filteredMultiple[0].recommend"
            style="background: url(images/svg/recommendation_star.svg) center left no-repeat; background-size: contain; padding-left: 30px; margin-bottom: 5px;"
          >オススメ</p>
          <p v-if="filteredMultiple[0].hot" class="hot">人気国</p>
          <div
            style="border-bottom: 1.8px solid #6091CD; margin-bottom: 10px; background: url(images/bg_img_aircraft.png) center right no-repeat; background-size: contain;"
          >
            <h4 style="font-size: 23px; font-weight: 600;">“{{filteredMultiple[0].title}}”プラン</h4>
            <p
              style="font-size: 17px; color: #FF0000; font-weight: 600; padding: 5px 0;"
            >最安 {{filteredMultiple[0].minPrice}}円/日〜</p>
          </div>
          <!--<p style="font-size: 15px; font-weight: 500;">{{filteredMultiple[0].description}}</p>-->
          <div style="font-size: 15px; font-weight: 500;" v-html="filteredMultiple[0].description"></div>
          <p class="btn" style="padding: 20px;">
            <a
              :href="getCountryUrl(filteredMultiple[0])"
              style="background-color: #f6d328; color: #222; font-weight: 600; font-size: 18px; text-align: center; display: block; border-radius: 50px; padding:16px 10px; box-shadow: 3px 3px 0 #808080;"
            >“{{filteredMultiple[0].title}}”の申し込みはこちら</a>
            <!--  
            <a
              href
              @click="onSelectCountry(filteredMultiple[0])"
              style="background-color: #FFC924; color: #222; font-weight: 600; font-size: 18px; text-align: center; display: block; border-radius: 50px; padding:16px 10px; box-shadow: 3px 3px 0 #808080;"
            >“{{filteredMultiple[0].title}}”の申し込みはこちら</a>-->
          </p>
          <div class="show_more_info">
            <h4 @click="onClickShowMoreInfo()">対応国一覧</h4>
            <div class="mob_show" v-show="showMoreInfo || largeScreen">
              <!--<p>{{filteredMultiple[0].countries}}</p>-->
              <div
                style="font-size: 15px; font-weight: 500;"
                v-html="filteredMultiple[0].countries"
              ></div>
            </div>
          </div>
        </div>
        <div class="area_photo clearfix">
          <div class="the_photo photo_01" :style="getBackgrounUrl(filteredMultiple[0].img_0)"></div>
          <div class="the_photo photo_02" :style="getBackgrounUrl(filteredMultiple[0].img_1)"></div>
          <div class="the_photo photo_03" :style="getBackgrounUrl(filteredMultiple[0].img_2)"></div>
          <div class="the_photo photo_04" :style="getBackgrounUrl(filteredMultiple[0].img_3)"></div>
          <div class="the_photo photo_05" :style="getBackgrounUrl(filteredMultiple[0].img_4)"></div>
        </div>
      </div>

      <!-- new -->
      <div style="max-width: 1070px; margin: 20px auto 10px auto;" v-if="filteredSingle.length">
        <div
          style=" width: 100%; text-align: center; background: url(images/bg_line_yellow.gif) center center repeat-x; padding: 0 20px;"
        >
          <h4
            style="font-size: 21px; font-weight: 600; background-color: #fff; padding: 5px 15px; min-width: 220px; display: inline-block;"
          >単国プラン</h4>
        </div>
        <p
          style=" font-size: 15px; padding: 10px 15px 18px 15px; text-align: center;"
          v-if="filteredMultiple.length"
        >
          １カ国しか行く予定がない場合は「単国プラン」！
          <br />
          <span
            style=" font-size: 11.5px; padding-top: 12px; display: inline-block; font-weight: 400;"
          >※「単国プラン」がない国もあります。その場合は「周遊プラン」を選択ください</span>
          <!-- 這行無法置左 -->
        </p>
      </div>
      <!-- old -->
      <!--
      <div class="sub_title_content" v-if="filteredSingle.length">
        <h4>
          <span>単国プラン</span>
        </h4>
        <p v-if="filteredMultiple.length"> 
          １カ国しか行く予定がない場合は「単国プラン」！
          <br />
          <span>※「単国プラン」がない国もあります。その場合は「周遊プラン」を選択ください</span>
        </p>
      </div>
      -->
      <ul class="area_list clearfix" v-if="filteredSingle.length">
        <li v-for="(country) in filteredSingle" :key="country.id">
          <a :href="getCountryUrl(country)">
          <!--<a href @click="onSelectCountry(country)">-->
            <div class="area_photo" :style="getBackgrounUrl(country.img_0)">
              <div class="labels clearfix">
                <p class="star img_default" v-if="country.recommend">オススメ</p>
                <p v-if="country.hot" class="hot">人気国</p>
              </div>
            </div>
            <div class="area_info">
              <h3 class="area_title">
                <span>
                  {{country.title}}
                  <!--<span class="f_s">プラン</span>-->
                </span>
              </h3>
              <h4 class="area_sub_title">最安{{country.minPrice? country.minPrice : ''}}円/日〜</h4>
            </div>
          </a>
        </li>
      </ul>

      <p class="btn_more" v-if="!largeScreen && !showMoreArea && filteredCountries.length>6">
        <a class="img_default" @click.stop.prevent="onClickShowMoreArea()">その他 単国プラン</a>
      </p>
      <JetfiCountryList v-if="filteredMultiple.length && filteredMultiple[0].global"></JetfiCountryList>
      <!--
      <JetfiCountryList
        v-if="filteredMultiple.length && filteredMultiple[0].global && (showMoreInfo || largeScreen)"
      ></JetfiCountryList>
      -->
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import JetfiCountryList from "@/components/JetfiCountryList.vue";

export default {
  name: "JetfiCountries",
  props: {},
  data: function() {
    return {
      baseUrl: process.env.BASE_URL,
      baseImageUrl: process.env.VUE_APP_BASE_IMAGE_URL,
      priceUrl: process.env.VUE_APP_PRICE_API,
      bid: process.env.VUE_APP_PLAN_BID,
      isLoading: false,
      fullPage: true,
      //areas: [],
      countries: [],
      prices: [],
      //getAreasErrorMessage: "",
      getCountriesErrorMessage: "",
      isCountriesLoaded: false,
      //isAreasLoaded: false,
      selectedCountry: null,
      selectedAreaId: null,
      currentArea: {},
      getAreaErrorMessage: "",
      isAreaLoaded: false,
      windowWidth: 0,
      newWindowWidth: 0,
      showMoreInfo: false,
      showMoreArea: false
    };
  },
  created: function() {
    // console.log(this.$store.state.isAreasLoaded);
    // this.getAreasErrorMessage = "";
    // this.isAreasLoaded = this.$store.state.isAreasLoaded;
    // this.areas = Vue.$sessionStorage.get("areas") || this.$store.state.areas;
    this.isCountriesLoaded = this.$store.state.isCountriesLoaded;
    this.getCountriesErrorMessage = "";
    this.countries = 
      Vue.$sessionStorage.get("countries") || this.$store.state.countries;
    this.selectedAreaId = this.$router.currentRoute.query.aid ||
      Vue.$sessionStorage.get("currentArea") || this.$store.state.currentArea;

    window.addEventListener("resize", this.onResize);
    this.onResize();

    console.log("[JetfiCountries] created", this.selectedAreaId);
  },
  mounted: function() {
    console.log("[JetfiCountries] mounted", this.selectedAreaId);

    this.initialize();
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    initialize() {
      console.log("[JetfiCountries] initialize");
      // if (this.areas.length === 0 && !this.isAreasLoaded) {
      //   this.getAreas();
      // }
      this.getAreaById();
      if (this.countries.length === 0 && !this.isCountriesLoaded) {
        this.getCountries();
      } else {
        this.getMinPrice();
      }
      //this.getMinPrice();
    },
    onResize() {
      this.newWindowWidth = window.innerWidth;

      if (this.newWindowWidth != this.windowWidth) {
        if (this.newWindowWidth > 780) {
          this.showMoreInfo = true;
          this.showMoreArea = true;
        } else {
          this.showMoreInfo = false;
          this.showMoreArea = false;
        }
        this.windowWidth = this.newWindowWidth;
      }
    },
    getBackgrounUrl(img) {
      // console.log(area.img_src)
      // let imageUrl = "images/" + area.img_src;
      if (img) {
        let imageUrl = encodeURI(this.baseImageUrl + "/" + img);
        //console.log(imageUrl);
        return {
          "background-image": `url(${imageUrl})`
        };
      } else {
        return {};
      }
    },
    getAreaById() {
      console.log("[JetfiCountries] get area by id");
      this.$store
        .dispatch("getAreaById", {
          params: {
            aid: this.selectedAreaId,
            type: this.$router.currentRoute.query.t,
            short: true
          }
        })
        .then(() => {
          console.log("[JetfiCountries] store area:", this.$store.state.area);
          this.isAreaLoaded = this.$store.state.isAreaLoaded;
          this.errorMessage = this.$store.state.getAreaErrorMessage;
          this.currentArea = this.$store.state.area || {};
        });
    },
    // getAreas() {
    //   this.$store
    //     .dispatch("getAreas", {
    //       params: {
    //         type: this.$router.currentRoute.query.t,
    //         short: true
    //       }
    //     })
    //     .then(() => {
    //       console.log("[JetfiCountries] store areas:", this.$store.state.areas);
    //       this.isAreasLoaded = this.$store.state.isAreasLoaded;
    //       this.errorMessage = this.$store.state.getAreasErrorMessage;
    //       this.areas = this.$store.state.areas;
    //     });
    // },
    getCountries() {
      this.isLoading = true;
      this.$store
        .dispatch("getCountries", {
          params: {
            type: this.$router.currentRoute.query.t,
            short: true,
            aid: this.selectedAreaId
          }
        })
        .then(() => {
          console.log(
            "[JetfiCountries] store cuntries:",
            this.$store.state.countries
          );
          this.isCountriesLoaded = this.$store.state.isCountriesLoaded;
          this.errorMessage = this.$store.state.getCountriesErrorMessage;
          this.countries = this.$store.state.countries;
          this.isLoading = false;
          if (this.countries.length) {
            this.getMinPrice();
          }
        });
    },
    getMinPrice() {
      console.log("[JetfiCountries] get min price");
      var codes = [];
      if (this.countries.length) {
        this.countries.forEach(function(country) {
          codes.push(country.page_code);
        });
      }
      axios
        .post(
          this.priceUrl,
          {
            business_id: this.bid,
            distributorCode: this.$router.currentRoute.query.d,
            couponCode: this.$router.currentRoute.query.c,
            pageCodes: codes
          },
          {
            withCredentials: false //allow cookie
          }
        )
        .then(response => {
          console.log("[JetfiCountries] get min price done", response.data);
          this.prices = response.data;
        })
        .catch(error => {
          console.log("[JetfiCountries] get min price failed", error.response);
          console.log(error);
        });
    },
    onClickShowMoreInfo: function() {
      this.showMoreInfo = !this.showMoreInfo;
      //console.log("onClickShowMoreInfo after click:", this.showMoreInfo);
    },
    onClickShowMoreArea: function() {
      this.showMoreArea = !this.showMoreArea;
    },
    getCountryUrl(country) {
      let param = Object.assign({}, this.$router.currentRoute.query);
      param["cid"] = country.id;
      var resolved = null;
      if (country.sns_code) {
        resolved = this.$router.resolve({
          path: "select-ch",
          query: param
        });
      } else {
        param["pcode"] = country.page_code;
        resolved = this.$router.resolve({
          path: "products",
          query: param
        });
      }
      return resolved.href;
    },
    onSelectCountry: function(country) {
      this.$store.dispatch("SetCurrentCountry", country).then(() => {
        console.log(
          "[JetfiCountries] SetCurrentCountry done:",
          this.$store.state.currentCountry
        );
        this.selectedCountry = Vue.$sessionStorage.get("currentCountry");
        //Vue.$sessionStorage.set('currentCountryName', country.name);
        if (country.sns_code) {
          //TBD
          this.$router
            .push({ path: "select-ch", query: this.$router.currentRoute.query })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("page code:", country.page_code);
          this.$store
            .dispatch("SetCurrentPageCode", country.page_code)
            .then(() => {
              console.log(
                "[JetfiCountries] SetCurrentPageCode done:",
                this.$store.state.currentPageCode
              );
              this.$router.push({
                path: "products",
                query: this.$router.currentRoute.query
              });
            });
          // this.$router.push({path: "products", query: this.$router.currentRoute.query});
        }
      });
    }
  },
  computed: {
    filteredCountries: function() {
      var self = this;
      // return self.countries.length
      //   ? self.countries.filter(function(country) {
      //       //console.log(country, country.area_id, country.area_id === self.selectedAreaId);
      //       return country.area_id == self.selectedAreaId;
      //     })
      //   : this.countries;
      // var myCountries = null;
      // if (self.countries.length) {
      //   myCountries = self.countries.filter(function(country) {
      //     //console.log(country, country.area_id, country.area_id === self.selectedAreaId);
      //     return country.area_id == self.selectedAreaId;
      //   });
      // } else {
      //   myCountries = this.countries;
      // }
      var myCountries = this.countries;
      if (self.prices.length) {
        myCountries.forEach(function(country) {
          var filtered = self.prices.filter(function(item) {
            return item.pageCode === country.page_code;
          });
          if (filtered.length) {
            country["minPrice"] = filtered[0]["minPrice"];
          } else {
            country["minPrice"] = "???";
          }
          if (country.sns_code) {
            filtered = self.prices.filter(function(item) {
              return item.page_code === country.sns_code;
            });
            if (filtered.length) {
              country["minPrice"] = Math.min(
                country["minPrice"],
                filtered[0]["minPrice"]
              );
            }
          }
        });
      }

      return myCountries;
      //return this.countries;
    },
    filteredSingle: function() {
      var self = this;
      let filtered = this.filteredCountries
        ? this.filteredCountries.filter(function(country) {
            return country.multi_countries === 0;
          })
        : this.countries;
      if (self.showMoreArea) {
        return filtered;
      } else {
        return filtered.slice(0, 6);
      }
    },
    filteredMultiple: function() {
      return this.filteredCountries
        ? this.filteredCountries.filter(function(country) {
            return country.multi_countries === 1;
          })
        : this.countries;
    },
    largeScreen: function() {
      return this.windowWidth > 780;
    }
  },
  components: {
    Loading,
    JetfiCountryList
  }
};
</script>
